import React, { useState, useEffect, useRef } from "react";
import {
  Typography,
  Box,
  useTheme,
  CardContent,
  Avatar,
  Card,
} from "@mui/material";
import { tokens } from "../../theme";
import "./Stylesheet.css";

const CardCom = ({ ContentData, maxWidth, borderRadius }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Card
      sx={{
        boxShadow: "none",
        maxWidth: maxWidth,
        marginTop: "30px",
        marginBottom: "30px",
        padding: "10px",
        borderRadius: borderRadius,
        backgroundColor: `${colors.blueAccent[300]}`,
        border: `.5px solid ${colors.grey[500]}`,
        width: "95%",
      }}
    >
      <CardContent>{ContentData}</CardContent>
    </Card>
  );
};

export default CardCom;
